export const getVisiblePeriods = (periods, expandedPeriods) => {
    if (periods == null || expandedPeriods == null) return [];

    const flags =
        typeof expandedPeriods === 'string'
            ? expandedPeriods.split('')
            : Array.isArray(expandedPeriods)
            ? expandedPeriods
            : [];

    const result = [];
    flags.forEach((isPeriod, index) => {
        if (isPeriod && periods[index] != null) result.push(periods[index]);
    });
    return result;
};

/** Text color of a period column: actuals black, budget green, forecast blue. */
export const periodStatusColor = (period) => {
    if (period?.forecast) return 'blue';
    if (period?.budget) return '#389e0d';
    return 'black';
};